import { Datagrid, FunctionField, List, TextField } from "react-admin";

import { ROWS_PER_PAGE } from "../constants";
import { OrganizationRecord } from "../types/organization";
import { ListTitle } from "./ListTitle";

const getAdminsCount = (record: OrganizationRecord) =>
  record?.practitioners?.nodes?.filter(p => p.role === "admin").length ?? 0;

const getManagerEmail = (record: OrganizationRecord) => {
  const manager = record?.organizationManagers?.nodes?.[0];
  return manager?.user?.email || "-";
};

export const OrganizationList = () => {
  return (
    <List resource="Organization" title={<ListTitle title="Einrichtungen" />} empty={false} perPage={ROWS_PER_PAGE}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="externalId" label="External ID" />
        <TextField source="postalCode" label="PLZ" />
        <TextField source="name" sortable={false} label="Einrichtung" />
        <FunctionField label="Manager" render={getManagerEmail} sortable={false} />
        <FunctionField label="Admins" render={getAdminsCount} />
        <TextField source="practitioners.totalCount" sortable={false} label="Mitarbeiter" />
        <TextField source="patients.totalCount" sortable={false} label="resources.Patient" />
      </Datagrid>
    </List>
  );
};
